import { axios } from '@Root/API'

export const updateInit = id => {
  return axios.put(`locked-forms/${id}`)
}
